<script>
	import { getContext, onDestroy } from 'svelte'
	import * as L from 'leaflet'
	import * as map from '../map'

	export let zoom = false
	export let staticBounds = null

	let hasZoomed = false

	const flight = getContext('flight')
	const store = flight && flight.serverStateStore

	$: if (!staticBounds) onServerStateUpdate($store)


	const boundsLayer = L.layerGroup()
	boundsLayer.addTo(map.getMap())
	const overlay = map.addOverlay("Bounds", boundsLayer, flight ? flight.overlay : null)
	let boundsRect

	$: if (staticBounds) {
		addBounds(staticBounds)
	}

	function addBounds(bounds) {
		clearBounds()
		if (!bounds) return
		if (zoom && !hasZoomed) {
			const params = new URLSearchParams(window.location.search)

			if (!params.get("lat") || !params.get("lng")) {
				hasZoomed = true
				map.getMap().fitBounds(L.latLngBounds([bounds.north, bounds.west], [bounds.south, bounds.east]))
			}
		}
		bounds = L.latLngBounds([[bounds.north, bounds.west], [bounds.south, bounds.east]])
		boundsRect = L.rectangle(bounds, {color: "#ff7800", weight: 2, fill: false, dashArray: "4 10"})
		boundsRect.addTo(boundsLayer)
	}

	function onServerStateUpdate(value) {
		if (!value) return
		let bounds = value.bounds
		addBounds(bounds)
	}

	function clearBounds() {
		if (boundsRect) {
			boundsRect.removeFrom(boundsLayer)
			boundsRect = null
		}
	}

	onDestroy(() => {
		clearBounds()
		if (overlay) map.removeOverlay(overlay, flight ? flight.overlay : undefined)
	})
</script>